import { render, staticRenderFns } from "./ConfirmModalEstoque.vue?vue&type=template&id=2c3127bf&"
import script from "./ConfirmModalEstoque.vue?vue&type=script&lang=js&"
export * from "./ConfirmModalEstoque.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports